<template>
  <v-list
    two-line
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          {{ themeTitle }}
        </v-list-item-title>
        <DsSwitch
          v-model="theme"
          class="px-5 ds-margin-top-inline--xs"
          :label="themeSwitchLabel"
        />
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="pb-4">
          {{ colorTitle }}
        </v-list-item-title>
        <v-row>
          <v-col cols="3">
            <v-color-picker
              v-model="color"
              hide-canvas
              show-swatches
              width="100%"
              :canvas-height="50"
            />
          </v-col>
          <v-col cols="6">
            <DsButton
              v-if="activeDashboard.data.color"
              color="secondary"
              class="mt-5"
              @click="clearColor"
            >
              {{ clearColorLabel }}
            </DsButton>
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>

    <br>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          {{ logoTitle }}
        </v-list-item-title>
        <v-row align="center">
          <v-col cols="6">
            <v-text-field
              v-model="logo"
              :placeholder="logoUrlPlaceholder"
              :full-width="false"
              width="250"
            />
          </v-col>
          <v-col cols="6">
            <span>
              <DashLogo
                v-if="logo"
                :logo="logo"
              />
              <v-row
                v-else
                class="fill-height ma-0 logo-placeholder"
                align="center"
                justify="center"
              >
                {{ noLogoSelectedLabel }}
              </v-row>
            </span>
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import DashLogo from '@/components/dashboard/DashLogo';
import { mapActions, mapGetters } from 'vuex';
import { DsButton, DsSwitch } from '@ds/components';
import { trackEventWithUserProperties } from '@/utils/mixpanel';

const changeColorEventName = 'ST Settings HeaderColor Edit';

export default {
  name: 'ConfigStyle',
  components: {
    DashLogo,
    DsButton,
    DsSwitch,
  },
  data() {
    return {
      logoUrlPlaceholder: 'ex: https://warroom.stilingue.com.br/img/logo.png',
      darkColor: '#23252E',
      lightColor: '#FFFFFF',
    };
  },
  computed: {
    noLogoSelectedLabel() {
      return this.$t('components.config.ConfigStyle.label.noLogoSelected');
    },
    logoTitle() {
      return this.$t('components.config.ConfigStyle.label.logoTitle');
    },
    colorTitle() {
      return this.$t('components.config.ConfigStyle.label.colorTitle');
    },
    themeTitle() {
      return this.$t('components.config.ConfigStyle.label.themeTitle');
    },
    clearColorLabel() {
      return this.$t('components.config.ConfigStyle.label.clearColor');
    },
    themeSwitchLabel() {
      return this.$t('components.config.ConfigStyle.label.themeSwitch');
    },
    ...mapGetters('dashboard', [
      'activeDashboard',
    ]),
    defaultColor() {
      return this.$vuetify.theme.dark ? this.darkColor : this.lightColor;
    },
    color: {
      get() {
        return this.activeDashboard.data.color || this.defaultColor;
      },
      set(newColor) {
        this.saveDashboardColor(newColor);
        trackEventWithUserProperties(changeColorEventName, { Color: newColor });
      },
    },
    theme: {
      get() {
        return this.activeDashboard.data.isDarkTheme || this.$vuetify.theme.dark;
      },
      set(newColor) {
        this.$vuetify.theme.dark = newColor;
        this.saveNewIsDarkTheme(newColor);
      },
    },
    logo: {
      get() {
        return this.activeDashboard.data.logo || null;
      },
      set(newLogo) {
        this.saveNewLogo(newLogo);
        trackEventWithUserProperties('ST Settings HeaderLogo Edit');
      },
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'saveDashboardColor',
      'saveNewIsDarkTheme',
      'saveNewLogo',
    ]),
    clearColor() {
      this.chooseColorIsOpen = false;
      this.saveDashboardColor(this.defaultColor);

      trackEventWithUserProperties(changeColorEventName, { Color: this.defaultColor });
    },
  },
};
</script>

<style scoped lang="scss">
  .logo-placeholder {
    background: var(--gray-600);
    color: var(--gray-300);
    height: 50px;
    width: 250px;
  }
</style>
